.TopBar {
  background: var(--primary);
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.15);
  height: var(--topbar-mobile-height);
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  z-index: 0;
  align-items: center;
  justify-content: space-between;
}

.TopbarDebug {
  background: var(--secondary);
}

.Title {
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  color: var(--concorso);
  margin-left: 8px;
}

.ContainerTitle {
  display: flex;
  align-items: center;
}

